import React, {useEffect, useState} from "react";
import {TextObservable} from "../../../stores/observables/textObservable";
import TextBox, {TextBoxType} from "../../atoms/input/textBox";
import {observer} from "mobx-react-lite";
import EditField from "../../molecules/editField/editField";
import {useTranslation} from "react-i18next";

export interface ITextEditProps {
  type: TextBoxType;
  value: TextObservable;
  label: string;
  validationMessage?: string;
  placeholder?: string;
  disabled?: boolean;
  helpText?: string;
}

const TextEdit: React.FC<ITextEditProps> = ({
  type,
  value,
  label,
  validationMessage,
  placeholder,
  disabled,
  helpText
}) => {
  const [finalValidationMessage, setFinalValidationMessage] = useState("");
  const {t} = useTranslation();

  useEffect(() => {
    const messages = [];
    if (!value.isLengthValid()) {
      messages.push(t("controls.characterLimitExceeded"));
    }
    if (!value.validate?.(value.text)) {
      messages.push(validationMessage);
    }
    setFinalValidationMessage(messages.join("; "));
  }, [validationMessage, value, value.text, t]);

  return (
    <EditField
      label={label}
      isRequired={value.validate != null}
      helpText={helpText}
    >
      <TextBox
        type={type}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        errorText={!value.isValid ? finalValidationMessage : ""}
        id={label}
      />
    </EditField>
  );
};
export default observer(TextEdit);
